import { createGlobalStyle } from "styled-components";
import { colors, fonts, media } from "./index";

export const GlobalStyle = createGlobalStyle`
  *, *::before, *::after { box-sizing: border-box; }

  html {
    scroll-behavior: smooth;
    -webkit-text-size-adjust: 100%;
    overflow-x: clip;
  }

  body {
    margin: 0;
    font-family: ${fonts.body};
    color: ${colors.ink};
    background: ${colors.surface};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    line-height: 1.5;
    font-size: 16px;
    overflow-x: clip;
    width: 100%;
    max-width: 100vw;
  }

  #root { overflow-x: clip; }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${fonts.display};
    color: ${colors.ink};
    margin: 0;
    letter-spacing: -0.02em;
    line-height: 1.1;
    font-weight: 700;
  }

  h1 { font-size: clamp(2.4rem, 5.2vw, 4.2rem); letter-spacing: -0.03em; }
  h2 { font-size: clamp(1.9rem, 3.4vw, 2.8rem); letter-spacing: -0.02em; }
  h3 { font-size: clamp(1.3rem, 2vw, 1.6rem); }

  p { margin: 0; color: ${colors.inkMuted}; line-height: 1.65; }

  a { color: inherit; text-decoration: none; }

  img, svg, video { display: block; max-width: 100%; }

  button { font-family: inherit; cursor: pointer; }

  ::selection { background: ${colors.brand}; color: white; }

  /* Mobile tap highlight */
  -webkit-tap-highlight-color: rgba(0,0,0,0);

  ${media.sm} {
    body { font-size: 15px; }
  }
`;
